export default __webpack_public_path__ + "static/media/geolocator-small.17a6c15b.png";